import React from 'react'
import ReactDOM from 'react-dom'
import './assets/styles/global-style.css'
import 'antd/dist/antd.css'
import { ThemeProvider } from 'styled-components'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import createStore from './store/store'
import * as serviceWorker from './serviceWorker'
import RouterPage from './routes/router'
import themeColor from './assets/styles/colors'

// A code-split chunk request can resolve to index.html (HTTP 200) after a
// deploy removes the old hashed files — the browser then parses HTML as JS
// and the route renders blank. Reload once to pull the current build.
function reloadOnChunkError(reason) {
  const text = String((reason && (reason.message || reason.name)) || reason || '')
  if (!/ChunkLoadError|Loading chunk|Loading CSS chunk|Unexpected token/.test(text)) return
  const KEY = 'chunkReloadAt'
  if (Date.now() - Number(sessionStorage.getItem(KEY) || 0) < 20000) return
  sessionStorage.setItem(KEY, String(Date.now()))
  window.location.reload()
}
window.addEventListener('error', (e) => reloadOnChunkError(e.error || e.message))
window.addEventListener('unhandledrejection', (e) => reloadOnChunkError(e.reason))

const store = createStore()

ReactDOM.render(
  <React.StrictMode>
      <ThemeProvider theme={themeColor}>
        <Provider store={store}>
            <Router>
                <RouterPage />
            </Router>
        </Provider>
      </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// Service worker disabled: this POS is always online, so offline caching adds
// no value, while its stale precache caused blank pages / outdated bundles
// after deploys. unregister() also tears down a SW already on a client.
serviceWorker.unregister()
